import { css } from 'styled-components/macro';
import * as colors from './colors';

export const scrollbarStyle = css`
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 8px 8px ${colors.BlueGray_500};
    border: solid 2px transparent;
  }
`;
